import "./style.css";
import { useEffect } from "react";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import { useHeader } from "../../Providers/HeaderContextProvider";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";

const LoginPage = () => {
  const { setHeaderContent } = useHeader();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setHeaderContent(false);
    if (Cookies.get("idtoken")) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="login-container">
      <LeftSection />
      <RightSection />
    </div>
  );
};

export default LoginPage;
